/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import { Flex } from '@bottlebooks/gatsby-design-system';
import { jsx } from 'theme-ui';

export default function ThumbnailContainer({
  children,
  height = 136,
  ...rest
}) {
  return (
    <Flex align="center" justify="center" sx={{ height }} {...rest}>
      {children}
    </Flex>
  );
}
